<template>
  <div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="130px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业名称(中文)" prop="CompanyNameCN">
            <el-input
              v-model="ruleForm.CompanyNameCN"
              placeholder="企业名称（英文）"
              maxlength="200"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业名称(英文)" prop="CompanyNameEN">
            <el-input
              v-model="ruleForm.CompanyNameEN"
              placeholder="企业名称（英文）"
              maxlength="200"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业简称" prop="CompanyShortName">
            <el-input
              v-model="ruleForm.CompanyShortName"
              placeholder="企业简称"
              maxlength="200"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人手机" prop="PhoneNumber">
            <el-input
              v-model="ruleForm.PhoneNumber"
              placeholder="联系人手机"
              maxlength="11"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="推荐机构" prop="RecommendInstitution">
            <el-select
              v-model="ruleForm.RecommendInstitution"
              placeholder="推荐机构"
              clearable
            >
              <el-option
                v-for="item in RecommendInstitutionList"
                :label="item.InstitutionName"
                :value="item.InstitutionName"
                :key="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人姓名" prop="ContactName">
            <el-input
              v-model="ruleForm.ContactName"
              placeholder="联系人姓名"
              maxlength="200"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系人职务" prop="ContactJob">
            <el-input
              v-model="ruleForm.ContactJob"
              placeholder="联系人职务"
              maxlength="200"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人座机" prop="ContactTelephone">
            <el-input
              v-model="ruleForm.ContactTelephone"
              placeholder="联系人座机"
              maxlength="100"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="联系人邮箱"
            prop="ContactEmail"
            :rules="[
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              v-model="ruleForm.ContactEmail"
              placeholder="联系人邮箱"
              maxlength="200"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业性质" prop="Industry">
            <el-select
              v-model="ruleForm.Industry"
              placeholder="企业性质"
              clearable
            >
              <el-option
                v-for="item in IndustryList"
                :label="item.Name"
                :value="item.Name"
                :key="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="总部所在地" prop="Location">
            <el-select
              v-model="ruleForm.Location"
              placeholder="总部所在地"
              clearable
            >
              <el-option
                v-for="item in LocationList"
                :label="item.Name"
                :value="item.Name"
                :key="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="员工人数" prop="EmployeeNum">
            <el-select
              v-model="ruleForm.EmployeeNum"
              placeholder="员工人数"
              clearable
            >
              <el-option
                v-for="item in EmployeeNumList"
                :label="item.Name"
                :value="item.Name"
                :key="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="成立时间" prop="EstablishDate">
            <el-date-picker
              v-model="ruleForm.EstablishDate"
              type="year"
              placeholder="选择成立时间"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="LogoAttachments"
            label="LOGO文件"
            :rules="[
              { required: true, message: '请上传LOGO文件', trigger: 'blur' },
            ]"
          >
            <div class="fileFlex">
              <el-upload
                :action="UploadApi"
                :before-upload="
                  (file) => {
                    return handleBeforeUpload(file, 1, null);
                  }
                "
                :on-success="
                  (response, file, fileList) => {
                    return handleSuccess(response, file, fileList, 1, null);
                  }
                "
                :limit="5"
                :on-error="uploadError"
                :on-remove="
                  (file, fileList) => {
                    return handleRemove(file, fileList, 1, null);
                  }
                "
                :file-list="ruleForm.LogoAttachments"
              >
                <el-button size="small" class="fontF" type="primary"
                  >选择附件</el-button
                >
                <span class="spanRemark">（最多上传5个文件）</span>
              </el-upload>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="CompanyDescription"
            label="企业介绍"
            :rules="[
              { required: true, message: '请输入企业介绍', trigger: 'blur' },
            ]"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              v-model="ruleForm.CompanyDescription"
              placeholder="企业介绍"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="AwardTypeIds"
            label="申报奖项"
            :rules="[
              {
                required: true,
                message: '请选择申报奖项',
                trigger: 'change',
              },
            ]"
          >
            <strong>请选择您要申报的奖项（最多2个）</strong>
            <el-checkbox-group
              v-model="ruleForm.AwardTypeIds"
              :max="2"
              @change="handleChecked"
            >
              <el-checkbox
                v-for="item in awardTypeList"
                :key="item.Id"
                :label="item.Id"
                >{{ item.Name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="display: none">
        <el-col :span="24">
          <template v-if="selectedAwardTypes.length > 0">
            <div
              class="awardsList"
              v-for="item in selectedAwardTypes"
              :key="item.Id"
            >
              <strong>{{ item.Name }}</strong>
              <ul class="awardsUl">
                <li>
                  <el-link type="primary" :href="item.ReportUrl" target="_blank"
                    >点击下载</el-link
                  >
                  提名表，并按要求填写及上传；
                </li>
                <li>
                  其他补充材料（如有），包括项目结案报告、方案、证书、视频、图片等信息，佐证填写内容，并以附件的形式上传。<br />
                  <strong
                    >注：请审慎填写以上信息，其中企业名称将作为后续评选、宣发、颁奖的文字信息，请核实、确认之后进行填写。</strong
                  >
                </li>
              </ul>
            </div>
          </template>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" class="btnClass">
          <!-- <el-form-item class="btnClass">
            <el-button @click="clickSave('ruleForm', 1)">保存</el-button>
            <br /><span>保存后数据为草稿状态，可进行修改</span>
          </el-form-item> -->

          <!-- 20240704 保存按钮始终显示 -->
          <el-form-item v-show="!btnSaveItem.IsHide">
            <template v-if="ruleForm.Status === 4">
              <el-button
                v-if="!btnSaveItem.IsHide"
                :type="getBtnType(btnSaveItem.Func)"
                v-prevent-re-click
                @click.once="callFunc(btnSaveItem)"
              >
                {{ btnSaveItem.name }}
              </el-button>
            </template>
            <template v-if="ruleForm.Status < 4">
              <el-button
                v-if="!btnSaveItem.IsHide"
                :disabled="ruleForm.Status == 3"
                :type="getBtnType(btnSaveItem.Func)"
                v-prevent-re-click
                @click.once="callFunc(btnSaveItem)"
              >
                {{ btnSaveItem.name }}
              </el-button>
            </template>
          </el-form-item>
          <el-form-item
            v-show="ruleForm.Status != 1"
            v-for="item in otherButtonList.filter((x) => x.name != '保存')"
            v-bind:key="item.id"
          >
            <template v-if="ruleForm.Status === 4">
              <el-button
                v-prevent-re-click
                :type="getBtnType(item.Func)"
                v-if="
                  (!item.IsHide && item.name == '终审通过') ||
                  (!item.IsHide && item.name == '退回')
                "
                @click.once="callFunc(item)"
                >{{ item.name }}</el-button
              >
            </template>
            <template v-if="ruleForm.Status < 4">
              <el-button
                v-prevent-re-click
                :type="getBtnType(item.Func)"
                v-if="!item.IsHide && item.name != '终审通过'"
                :disabled="item.name == '退回' && ruleForm.Status == 3"
                @click.once="callFunc(item)"
                >{{ item.name }}</el-button
              >
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"> &nbsp; </el-col>
        <el-col :span="12">
          <el-button
            type="success"
            round
            @click="clickBackButton"
            style="display: flex; justify-content: center"
            >返回上一页</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <br /><br />
     <el-table
      v-show="isShowTabData"
      :data="tabData"
      border=""
      ref="table"
      style="width: 100%"
    >
      <el-table-column type="index" label="编号" width="80"></el-table-column>
      <el-table-column prop="Type" label="附件类型" width="100"
        ><template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.Type == 1">LOGO</el-tag>
          <el-tag type="success" v-else-if="scope.row.Type == 2">奖项</el-tag>
          <el-tag type="warning" v-else>补交</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="Content" label="备注内容"></el-table-column>
      <el-table-column prop="Remark" label="退回缘由"></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="提交时间"
        width="150"
      ></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-prevent-re-click
            v-if="scope.row.Url"
            @click="downloadFile(scope.row)"
            >下载文件</el-button
          >
        </template>
      </el-table-column>
    </el-table>
       <br /><br />   <br /><br />
    <el-table
      v-show="isShowTabData"
      :data="tabData"
      border=""
      ref="table"
      style="width: 100%"
    >
      <el-table-column type="index" label="编号" width="80"></el-table-column>
      <el-table-column prop="Type" label="附件类型" width="100"
        ><template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.Type == 1">LOGO</el-tag>
          <el-tag type="success" v-else-if="scope.row.Type == 2">奖项</el-tag>
          <el-tag type="warning" v-else>补交</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="Content" label="备注内容"></el-table-column>
      <el-table-column prop="Remark" label="退回缘由"></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="提交时间"
        width="150"
      ></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-prevent-re-click
            v-if="scope.row.Url"
            @click="downloadFile(scope.row)"
            >下载文件</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <br /><br />
    <el-dialog title="退回原因" :visible.sync="dialogVisible" width="50%">
      <el-form :model="dialogForm" ref="dialogForm">
        <el-form-item
          prop="content"
          :rules="[
            { required: true, message: '请输入退回原因', trigger: 'blur' },
          ]"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 8 }"
            v-model="dialogForm.content"
            placeholder="退回原因"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click.once="submitForm('dialogForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <el-button type="success" round class="backButton" @click="clickBackButton"
      >返回上一页</el-button
    > -->
  </div>
</template>

<script>
import {
  getAwardInfoById,
  getApplyAwardTypeListByAwardId,
  getEmployeeNumRange,
  getIndustryList,
  getProvinceList,
  getInstitutionList,
  getAwardModify,
  awardUpdateStatus,
  getReplenishList,
  submitSendnotice,
  addAwardReplenish,
  getAttachmentUrl,
  getAwardAttachmentList,
} from "../../api/api";
import store from "@/store";
import { getButtonList } from "../../promissionRouter";

export default {
  computed: {
    btnSaveItem() {
      return this.otherButtonList.find((x) => x.name == "保存") || {};
    },
  },
  data() {
    return {
      UploadApi: `${process.env.VUE_APP_BASE_API}/api/AwardApplication/upload`,
      loadingCompanyName: false, // 适用活动 加载效果
      CompanyList: [], // 公司列表
      otherButtonList: [], // 按钮列表
      ruleForm: {
        id: 0, // 页面传过来的ID
        AwardId: 0, // 页面传入的ID,
        CompanyNameCN: "",
        CompanyNameEN: "",
        CompanyShortName: "",
        SCC: "",
        PhoneNumber: "",
        SMSCode: "",
        SmsType: "award",
        cacheTime: "28800",
        ContactName: "",
        ContactJob: "",
        ContactTelephone: "",
        ContactEmail: "",
        Industry: "",
        Location: "",
        EmployeeNum: "",
        EstablishDate: "",
        RecommendInstitution: "",
        LogoAttachments: [],
        CompanyDescription: "",
        AwardTypeIds: [], // 选择的奖项ID
        AwardAttachments: [],
        Status: 0, // 草稿 = 1,未审核 = 2, = 3,待终审 = 4,通过 = 5
      },
      EmployeeNumList: [], // 员工人数
      IndustryList: [], // 企业性质
      LocationList: [], // 总部所在地
      RecommendInstitutionList: [], // 推荐机构
      selectedAwardTypes: [], // 选中的奖项类型
      awardTypeList: [], // 奖项类型列表

      tabData: [],
      isShowTabData: false, // 是否显示补录信息
      dialogVisible: false, // 退回原因
      dialogForm: {
        content: "",
      },
    };
  },
  methods: {
    getBtnType(func) {
      if (
        func &&
        (func.toLowerCase().indexOf("handledel") != -1 ||
          func.toLowerCase().indexOf("stop") != -1)
      )
        return "danger";
      return "primary";
    },
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    clickBackButton() {
      this.$router.push(`/DetpActivity/AwardList`);
    },
    // 退回
    handleReturn() {
      this.dialogVisible = true;
      // awardUpdateStatus({
      //   id:this.ruleForm.id,
      //   status: 3
      // }).then(res => {
      //   if(res.data.success) {
      //     this.$message({
      //       type: 'success',
      //       message: res.data.msg,
      //     })
      //   } else {
      //     this.$message({
      //       type: 'warning',
      //       message: res.data.msg,
      //     })
      //   }
      // })
    },

    // 退回原因 并 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            AwardApplicationId: store.getters.getAwardDetailId,
            Remark: this.dialogForm.content,
          };
          addAwardReplenish(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              // 发送短信
              let sendnotice = {
                Id: store.getters.getAwardDetailId,
                EncryptId: "",
                SignName: "HRoot",
                TemplateCode: "SMS_465665188",
                Remark: this.dialogForm.content,
                AwardApplicationReplenishId:
                  res.data.response.AwardApplicationReplenishId,
              };
              submitSendnotice(sendnotice).then((res) => {
                console.log("sms res", res);
              });
              this.getAwardInfoById();
              this.getReplenishList();
              this.dialogVisible = false;
            } else {
              this.$message({
                type: "warning",
                message: res.data.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 保存
    handleSave() {
      getAwardModify(this.ruleForm).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
    // 初审通过
    handleTrial() {
      awardUpdateStatus({
        id: this.ruleForm.id,
        status: 4,
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
    // 终审通过
    handleFinal() {
      awardUpdateStatus({
        id: this.ruleForm.id,
        status: 5,
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });

          // 发送短信
          let sendnotice = {
            Id: store.getters.getAwardDetailId,
            EncryptId: "",
            SignName: "HRoot",
            TemplateCode: "SMS_465675202",
            Remark: "",
          };
          submitSendnotice(sendnotice).then((res) => {
            console.log("sms res", res);
          });
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
    // 下载补录附件
    downloadFile(item) {
      // const compName = this.ruleForm.CompanyNameCN
      const a = document.createElement("a"); // 创建一个a标签用于下载
      // a.download = compName + '_补录附件列表' + new Date().getTime() + '.zip' //文件名
      a.href = item.Url;
      a.setAttribute("target", "_blank");
      a.click();
      a.remove();
      // const compName = this.ruleForm.CompanyNameCN
      // const zipName = compName + '_补录附件列表' + new Date().getTime()
      // // Id：填报记录的ID；AwardApplicationReplenishId：补录数据的ID； Type：3 代表补交附件
      // const params = {
      //   Id: store.getters.getAwardDetailId,
      //   AwardApplicationReplenishId: item.Id,
      //   Type: 3,
      //   ZipName: zipName,
      // }
      // getAttachmentUrl(params).then((res) => {
      //   console.log('file BL res', res)
      //   if (res.data.success) {
      //     saveAs(res.data.response, zipName + '.zip')
      //   }
      // })
      // this.$notify({
      //   title: '成功',
      //   message: '正在下载，请耐心等待！',
      //   type: 'success',
      //   duration: 5000,
      // })
      // const token = window.localStorage.getItem('Token')
      // const url = `${process.env.VUE_APP_BASE_API}/api/AwardApplication/attachment/export`
      // const xhr = new XMLHttpRequest()
      // const compName = this.ruleForm.CompanyNameCN
      // const zipName = compName + '_补录附件列表' + new Date().getTime()
      // xhr.open('post', url, true)
      // // 2.2 设置请求头,作用是设置参数的编码格式，以便后台能够正确的接收所传递的参数
      // xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      // xhr.responseType = 'blob' // 返回类型blob
      // xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验
      // xhr.onload = function () {
      //   if (this.status === 200) {
      //     const blob = this.response
      //     saveAs(blob, zipName + '.zip')
      //     // var reader = new FileReader()
      //     // reader.readAsDataURL(blob) // 转换为base64
      //     // reader.onload = function (e) {
      //     //   var a = document.createElement('a') // 创建一个a标签用于下载
      //     //   a.download =
      //     //     compName + '_补录附件列表' + new Date().getTime() + '.zip' //文件名
      //     //   a.href = e.target.result
      //     //   a.click()
      //     //   $(a).remove()
      //     // }
      //   }
      // }
      // // Id：填报记录的ID；AwardApplicationReplenishId：补录数据的ID； Type：3 代表补交附件
      // const params = {
      //   Id: store.getters.getAwardDetailId,
      //   AwardApplicationReplenishId: item.Id,
      //   Type: 3,
      // }
      // xhr.send(JSON.stringify(params))
    },

    // 奖项类型选择事件
    handleChecked(val) {
      this.selectedAwardTypes = this.awardTypeList.filter((a) =>
        val.includes(a.Id)
      );
    },

    // 根据 ID 获取详情
    getAwardInfoById() {
      getAwardInfoById(store.getters.getAwardDetailId).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response;
          this.selectedAwardTypes = this.awardTypeList.filter((a) =>
            this.ruleForm.AwardTypeIds.includes(a.Id)
          );
          this.ruleForm.id = store.getters.getAwardDetailId;
        } else {
          return false;
        }
      });
    },
    getAwardAttachmentList() {
      getAwardAttachmentList(store.getters.getAwardDetailId).then((res) => {
        if (res.data.success) {
          this.tabData = res.data.response;
          if (res.data.response.length === 0) {
            this.isShowTabData = false;
          } else {
            this.isShowTabData = true;
          }
        } else {
          return false;
        }
      });
    },
    // 根据 填报数据时的 ID 查询补录记录
    getReplenishList() {
      getReplenishList(store.getters.getAwardDetailId).then((res) => {
        if (res.data.success) {
          this.tabData = res.data.response;
          if (res.data.response.length === 0) {
            this.isShowTabData = false;
          } else {
            this.isShowTabData = true;
          }
        } else {
          return false;
        }
      });
    },

    uploadError(err, file, fileList) {
      this.$message({
        type: "error",
        message: "上传文件失败！",
      });
    },
    handleBeforeUpload(file, type, awardTypeId) {
      console.log(file);
      console.log(type);
      console.log(awardTypeId);
      var regEn = /[.`~!#$%^&*+<>?:"{},\/;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
      if (regEn.test(file.name) || regCn.test(file.name)) {
        this.$message({
          type: "warning",
          message: "文件名称不能包含特殊字符,()_除外",
        });
        return false;
      }
      if (type == 1) {
        var some = this.ruleForm.LogoAttachments.some(
          (a) => (a.name == file.name) & (a.Type == type)
        );
        if (some) {
          this.$message({
            type: "warning",
            message: "上传文件名称不能相同",
          });
          return false;
        }
      } else if (type == 2) {
        var some = this.ruleForm.AwardAttachments.some(
          (a) =>
            a.name == file.name &&
            a.Type == type &&
            a.AwardTypeId == awardTypeId
        );
        if (some) {
          this.$message({
            type: "warning",
            message: "上传文件名称不能相同",
          });
          return false;
        }
      }
      return true;
    },
    handleSuccess(response, file, fileList, type, awardTypeId) {
      let attachment = {
        url: response.response,
        name: file.raw.name,
        ContentType: file.raw.type,
        Type: type,
        AwardTypeId: awardTypeId,
      };
      if (type == 1) {
        this.ruleForm.LogoAttachments.push(attachment);
      } else if (type == 2) {
        this.ruleForm.AwardAttachments.push(attachment);
      }
    },
    handleRemove(file, fileList, type, awardTypeId) {
      if (type == 1) {
        this.ruleForm.LogoAttachments = this.ruleForm.LogoAttachments.filter(
          (a) => (a.name != file.name) & (a.Type == type)
        );
      } else if (type == 2) {
        this.ruleForm.AwardAttachments = this.ruleForm.AwardAttachments.filter(
          (a) =>
            a.name != file.name &&
            a.Type == type &&
            a.AwardTypeId == awardTypeId
        );
      }
    },

    // 获取奖项列表
    getApplyAwardTypeListByAwardId() {
      getApplyAwardTypeListByAwardId({
        AwardId: store.getters.getAwardId,
      }).then((res) => {
        if (res.data.success) {
          this.awardTypeList = res.data.response;
        }
      });
    },
    // 获取员工数量范围
    getEmployeeNumRange() {
      getEmployeeNumRange().then((res) => {
        if (res.data.success) {
          this.EmployeeNumList = res.data.response;
        }
      });
    },
    // 获取所属行业列表
    getIndustryList() {
      getIndustryList().then((res) => {
        if (res.data.success) {
          this.IndustryList = res.data.response;
        }
      });
    },
    // 获取城市列表
    getProvinceList() {
      getProvinceList().then((res) => {
        if (res.data.success) {
          this.LocationList = res.data.response;
        }
      });
    },
    // 推荐机构列表
    getInstitutionList() {
      getInstitutionList().then((res) => {
        if (res.data.success) {
          this.RecommendInstitutionList = res.data.response;
        }
      });
    },
  },
  mounted() {
    this.getAwardInfoById();
    this.getApplyAwardTypeListByAwardId();
    this.getEmployeeNumRange();
    this.getIndustryList();
    this.getProvinceList();
    this.getInstitutionList();
    // this.getReplenishList()
    this.getAwardAttachmentList();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let buttonList = getButtonList(this.$route.path, routers);
    this.otherButtonList = buttonList.filter((item) => {
      return item.ButtonType === 2;
    });
    console.log("buttonList", this.otherButtonList);
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.awardsList {
  font-size: 14px;
  line-height: 22px;
  border: 1px solid #ccc;
  margin: 0 0 30px 130px;
  padding: 20px;
  color: #606266;
  border-radius: 4px;
  box-shadow: 0 0 20px 0 rgba(65, 67, 70, 0.1);
}
.awardsUl {
  margin: 0;
  padding: 0 0 0 20px;
}
.btnClass {
  display: flex;
  flex-wrap: nowrap;
}
.backButton {
  position: fixed;
  right: 100px;
  bottom: 100px;
}
</style>
